// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./assets/fonts/Montserrat/Montserrat-Regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./assets/fonts/Montserrat/Montserrat-Medium.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./assets/fonts/Montserrat/Montserrat-SemiBold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./assets/fonts/Montserrat/Montserrat-Bold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("./assets/fonts/Montserrat/Montserrat-ExtraBold.woff2", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
    --graybg: #f5f5f5;
    --cardBg: white;
    --themeColor: rgb(38,178,253);

    /* --themeColor: #2196f3; */
    --fontColor: var(--themeColor);
    --bs-info: var(--themeColor) !important;
    --fontFamily: "Montserrat";
    --arrow-bg: rgb(196 196 196);
    --arrow-icon: url(https://upload.wikimedia.org/wikipedia/commons/9/9d/Caret_down_font_awesome_whitevariation.svg);
    --file-attachement: url(https://www.svgrepo.com/show/451688/mail-attachment.svg);
    --arrow-down:url(https://www.svgrepo.com/show/80156/down-arrow.svg);
    --option-bg: white;
    --select-bg: rgba(255, 255, 255, 0.2);
}

*{
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    font-family: var(--fontFamily);
}
a {
    /* color: var(--bs-link-color); */
    text-decoration: underline;
    text-decoration: none;
}

/* Montserrat - Regular (400) */
@font-face {
    font-family: 'Montserrat';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('woff2');
    font-weight: 400;
    font-style: normal;
    font-display: swap;
}

/* Montserrat - Medium (500) */
@font-face {
    font-family: 'Montserrat';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('woff2');
    font-weight: 500;
    font-style: normal;
    font-display: swap;
}

/* Montserrat - SemiBold (600) */
@font-face {
    font-family: 'Montserrat';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('woff2');
    font-weight: 600;
    font-style: normal;
    font-display: swap;
}

/* Montserrat - Bold (700) */
@font-face {
    font-family: 'Montserrat';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format('woff2');
    font-weight: 700;
    font-style: normal;
    font-display: swap;
}

/* Montserrat - ExtraBold (800) */
@font-face {
    font-family: 'Montserrat';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format('woff2');
    font-weight: 800;
    font-style: normal;
    font-display: swap;
}

.technum-opus-pvt-ltd-secondary-btn {
    background: transparent;
    color: #00a896;
    border: 1.5px solid #00a896;
}

.technum-opus-pvt-ltd-secondary-btn:hover {
    background: rgba(0, 168, 150, 0.05);
    border-color: #007b67;
    color: #007b67;
}

.technum-opus-pvt-ltd-primary-btn {
    background: var(--technum-teal);
    color: var(--technum-white);
    border: none;
    padding: 12px 24px;
    border-radius: 8px;
    font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
    font-weight: 500;
    font-size: 16px;
    text-decoration: none;
    transition: all 0.3s ease;
    cursor: pointer;
    display: inline-block;
}

.technum-opus-pvt-ltd-primary-btn:hover {
    background: var(--technum-teal-hover);
    transform: translateY(-2px);
}

/* ---------- Touch Device: disable hover transforms ---------- */
@media (hover: none) {
  .technum-opus-pvt-ltd-primary-btn:hover {
    transform: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,eAAe;IACf,6BAA6B;;IAE7B,2BAA2B;IAC3B,8BAA8B;IAC9B,uCAAuC;IACvC,0BAA0B;IAC1B,4BAA4B;IAC5B,iHAAiH;IACjH,gFAAgF;IAChF,mEAAmE;IACnE,kBAAkB;IAClB,qCAAqC;AACzC;;AAEA;IACI,SAAS;IACT,UAAU;IACV,sBAAsB;IACtB,8BAA8B;AAClC;AACA;IACI,iCAAiC;IACjC,0BAA0B;IAC1B,qBAAqB;AACzB;;AAEA,+BAA+B;AAC/B;IACI,yBAAyB;IACzB,4DAA8E;IAC9E,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA,8BAA8B;AAC9B;IACI,yBAAyB;IACzB,4DAA6E;IAC7E,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA,gCAAgC;AAChC;IACI,yBAAyB;IACzB,4DAA+E;IAC/E,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA,4BAA4B;AAC5B;IACI,yBAAyB;IACzB,4DAA2E;IAC3E,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA,iCAAiC;AACjC;IACI,yBAAyB;IACzB,4DAAgF;IAChF,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,uBAAuB;IACvB,cAAc;IACd,2BAA2B;AAC/B;;AAEA;IACI,mCAAmC;IACnC,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,+BAA+B;IAC/B,2BAA2B;IAC3B,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,+EAA+E;IAC/E,gBAAgB;IAChB,eAAe;IACf,qBAAqB;IACrB,yBAAyB;IACzB,eAAe;IACf,qBAAqB;AACzB;;AAEA;IACI,qCAAqC;IACrC,2BAA2B;AAC/B;;AAEA,iEAAiE;AACjE;EACE;IACE,eAAe;EACjB;AACF","sourcesContent":[":root {\n    --graybg: #f5f5f5;\n    --cardBg: white;\n    --themeColor: rgb(38,178,253);\n\n    /* --themeColor: #2196f3; */\n    --fontColor: var(--themeColor);\n    --bs-info: var(--themeColor) !important;\n    --fontFamily: \"Montserrat\";\n    --arrow-bg: rgb(196 196 196);\n    --arrow-icon: url(https://upload.wikimedia.org/wikipedia/commons/9/9d/Caret_down_font_awesome_whitevariation.svg);\n    --file-attachement: url(https://www.svgrepo.com/show/451688/mail-attachment.svg);\n    --arrow-down:url(https://www.svgrepo.com/show/80156/down-arrow.svg);\n    --option-bg: white;\n    --select-bg: rgba(255, 255, 255, 0.2);\n}\n\n*{\n    margin: 0;\n    padding: 0;\n    box-sizing: border-box;\n    font-family: var(--fontFamily);\n}\na {\n    /* color: var(--bs-link-color); */\n    text-decoration: underline;\n    text-decoration: none;\n}\n\n/* Montserrat - Regular (400) */\n@font-face {\n    font-family: 'Montserrat';\n    src: url('./assets/fonts/Montserrat/Montserrat-Regular.woff2') format('woff2');\n    font-weight: 400;\n    font-style: normal;\n    font-display: swap;\n}\n\n/* Montserrat - Medium (500) */\n@font-face {\n    font-family: 'Montserrat';\n    src: url('./assets/fonts/Montserrat/Montserrat-Medium.woff2') format('woff2');\n    font-weight: 500;\n    font-style: normal;\n    font-display: swap;\n}\n\n/* Montserrat - SemiBold (600) */\n@font-face {\n    font-family: 'Montserrat';\n    src: url('./assets/fonts/Montserrat/Montserrat-SemiBold.woff2') format('woff2');\n    font-weight: 600;\n    font-style: normal;\n    font-display: swap;\n}\n\n/* Montserrat - Bold (700) */\n@font-face {\n    font-family: 'Montserrat';\n    src: url('./assets/fonts/Montserrat/Montserrat-Bold.woff2') format('woff2');\n    font-weight: 700;\n    font-style: normal;\n    font-display: swap;\n}\n\n/* Montserrat - ExtraBold (800) */\n@font-face {\n    font-family: 'Montserrat';\n    src: url('./assets/fonts/Montserrat/Montserrat-ExtraBold.woff2') format('woff2');\n    font-weight: 800;\n    font-style: normal;\n    font-display: swap;\n}\n\n.technum-opus-pvt-ltd-secondary-btn {\n    background: transparent;\n    color: #00a896;\n    border: 1.5px solid #00a896;\n}\n\n.technum-opus-pvt-ltd-secondary-btn:hover {\n    background: rgba(0, 168, 150, 0.05);\n    border-color: #007b67;\n    color: #007b67;\n}\n\n.technum-opus-pvt-ltd-primary-btn {\n    background: var(--technum-teal);\n    color: var(--technum-white);\n    border: none;\n    padding: 12px 24px;\n    border-radius: 8px;\n    font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;\n    font-weight: 500;\n    font-size: 16px;\n    text-decoration: none;\n    transition: all 0.3s ease;\n    cursor: pointer;\n    display: inline-block;\n}\n\n.technum-opus-pvt-ltd-primary-btn:hover {\n    background: var(--technum-teal-hover);\n    transform: translateY(-2px);\n}\n\n/* ---------- Touch Device: disable hover transforms ---------- */\n@media (hover: none) {\n  .technum-opus-pvt-ltd-primary-btn:hover {\n    transform: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
